import React from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Layout from "./components/Layout";
import Navbar from "./components/Navbar";
import TodoContainer from "./components/TodoContainer";
import TodoList from "./components/TodoList";

const App = () => {
  return (
    <Layout>
      <Navbar />
      <TodoContainer>
        <Header />
        <TodoList />
        <Footer />
      </TodoContainer>
    </Layout>
  );
};

export default App;
